"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/TeamPage/KeywordsTab/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _phone = require('shared/services/phone');
var _keywords = require('shared/validation/team/keywords');
var _noticeBar = require('web/services/context/noticeBar');

var _Form = require('web/components/Form');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _components = require('web/screens/Directory/TeamPage/components');
var _hooks = require('web/screens/Directory/TeamPage/hooks');
var _CopyPrompts = require('./CopyPrompts'); var _CopyPrompts2 = _interopRequireDefault(_CopyPrompts);
var _KeywordForm = require('./KeywordForm'); var _KeywordForm2 = _interopRequireDefault(_KeywordForm);
var _copy = require('./copy');
var _Preview = require('./Preview');











// The org's STOP line when it hasn't set its own.
const DEFAULT_STOP_LINE = 'Reply STOP to stop'

const alsoWords = ([, ...rest]) => `Also ${rest.join(', ')}`

const BUILT_INS = [
  { words: _keywords.RESERVED_KEYWORDS.optOut, does: 'The person is opted out and gets no more texts.' },
  { words: _keywords.RESERVED_KEYWORDS.optIn, does: 'Texts turn back on for that person.' },
  { words: _keywords.RESERVED_KEYWORDS.help, does: 'The carrier sends its help reply. The text still reaches your inbox.' },
].map(({ words, does }) => ({ word: words[0], also: alsoWords(words), does }))

const BuiltIns = () => {
  const [isOpen, setIsOpen] = _react.useState.call(void 0, false)
  return (
    _react2.default.createElement('div', { className: "team-page--keywords--built-ins", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
      , _react2.default.createElement('div', { className: "team-page--keywords--built-ins-head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 42}}
        , _react2.default.createElement('img', { src: "/assets/icons/padlock.svg", alt: "", className: "team-page--keywords--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}} )
        , _react2.default.createElement('div', { className: "team-page--keywords--built-ins-text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 44}}, "Built in: "
            , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 45}}, "STOP · START · HELP · INFO"      )
          ,  ' ' 
          , _react2.default.createElement('span', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 47}}, "(can’t be keywords)"  )
        )
        ,  !isOpen && (
          _react2.default.createElement('button', { type: "button", className: "team-page--keywords--link-btn", onClick: () => setIsOpen(true), __self: this, __source: {fileName: _jsxFileName, lineNumber: 50}}, "Show all"

          )
        )
      )
      ,  isOpen && BUILT_INS.map(b => (
        _react2.default.createElement('div', { key: b.word, className: "team-page--keywords--built-in", __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
          , _react2.default.createElement('span', { className: "team-page--keywords--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 57}},  b.word )
          , _react2.default.createElement('span', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 58}},  b.also )
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 59}},  b.does )
        )
      ))
    )
  )
}

const STEPS = [
  { title: 'Families learn the word', detail: 'from your welcome text' },
  { title: 'They text it', detail: 'and get your reply right away' },
  { title: 'Your team follows up', detail: 'from Requests, if you flag it' },
]

const Steps = () => (
  _react2.default.createElement('ol', { className: "team-page--keywords--steps", role: "list", 'aria-label': "How keywords work"  , __self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}
    ,  STEPS.map((step, i) => (
      _react2.default.createElement('li', { key: step.title, className: "team-page--keywords--step", __self: this, __source: {fileName: _jsxFileName, lineNumber: 75}}
        , _react2.default.createElement('span', { className: "team-page--keywords--step-num", 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 76}},  i + 1 )
        , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
          , _react2.default.createElement('span', { className: "team-page--keywords--strong", __self: this, __source: {fileName: _jsxFileName, lineNumber: 78}},  step.title )
          ,  ' ' 
          , _react2.default.createElement('span', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 80}},  step.detail )
        )
      )
    ))
  )
)

// The keyword the preview shows; WELCOME shows the first text alone.
const WELCOME = ''

const KeywordsTab = ({ teamKey, teamName, phoneNumber, canEdit }) => {
  const { settings, isLoaded, saveKeywords, saveWelcome } = _hooks.useTeamReplySettings.call(void 0, teamKey)
  const { showSuccessBar, showWarningBar } = _noticeBar.useNoticeBar.call(void 0, )
  const [editing, setEditing] = _react.useState(null)
  const [deleting, setDeleting] = _react.useState.call(void 0, '')
  const [shownWord, setShownWord] = _react.useState(null)
  const [draft, setDraft] = _react.useState(null)
  const keywords = settings.Keywords
  const phone = _phone.formatPhoneNumber.call(void 0, phoneNumber) || phoneNumber
  const line = _copy.welcomeLine.call(void 0, keywords)
  const stopLine = settings.StopLineOn ? settings.StopLineText || DEFAULT_STOP_LINE : ''
  const hasWelcomeLine = settings.Welcome && !!stopLine

  // Saves the whole list. A refusal with a message rejects with it, for the
  // form to show; any other failure shows the notice bar.
  const save = _react.useCallback.call(void 0, 
    (list, done) => saveKeywords(list)
      .then(() => showSuccessBar(done))
      .catch((err) => {
        if (!_KeywordForm.serverMessage.call(void 0, err)) showWarningBar('Failed to save the keyword')
        throw err
      }),
    [saveKeywords, showSuccessBar, showWarningBar],
  )

  const others = _optionalChain([editing, 'optionalAccess', _ => _.kind]) === 'edit'
    ? keywords.filter(k => k.Keyword !== editing.keyword)
    : keywords

  // The list as saving k would store it: in its place when editing, last
  // when new. The preview takes the welcome line from it too.
  const savedList = (k) => _optionalChain([editing, 'optionalAccess', _2 => _2.kind]) === 'edit'
    ? keywords.map(old => old.Keyword === editing.keyword ? k : old)
    : [...keywords, k]

  const startEditing = (next) => {
    setDraft(null)
    setEditing(next)
  }
  const stopEditing = () => {
    setDraft(null)
    setEditing(null)
  }

  const onSaveForm = (k) =>
    save(savedList(k), `Keyword ${k.Keyword} has been saved`).then(() => {
      setShownWord(k.Keyword)
      stopEditing()
    })

  const onFlip = (k, Flags) =>
    save(keywords.map(old => old === k ? { ...k, Flags } : old), `Keyword ${k.Keyword} has been saved`)
      .catch((err) => { if (_KeywordForm.serverMessage.call(void 0, err)) showWarningBar(_KeywordForm.serverMessage.call(void 0, err)) })

  const onConfirmDelete = () => {
    const word = deleting
    setDeleting('')
    stopEditing()
    save(keywords.filter(k => k.Keyword !== word), `Keyword ${word} has been deleted`)
      .catch((err) => { if (_KeywordForm.serverMessage.call(void 0, err)) showWarningBar(_KeywordForm.serverMessage.call(void 0, err)) })
  }

  const onToggleWelcome = (isOn) => saveWelcome(isOn)
    .catch((err) => showWarningBar(_KeywordForm.serverMessage.call(void 0, err) || 'Failed to save the welcome text setting'))

  const onDraft = _react.useCallback.call(void 0, 
    (keyword, isPhraseFocused) => setDraft({ keyword, isPhraseFocused }),
    [],
  )

  const form = (keyword) => (
    _react2.default.createElement(_KeywordForm2.default, {
      keyword: keyword,
      others: others,
      onSave: onSaveForm,
      onCancel: stopEditing,
      onDelete: keyword ? () => setDeleting(keyword.Keyword) : undefined,
      onDraft: onDraft, __self: this, __source: {fileName: _jsxFileName, lineNumber: 161}}
    )
  )

  if (!isLoaded) return null

  const isEmpty = !keywords.length && _optionalChain([editing, 'optionalAccess', _3 => _3.kind]) !== 'new'
  const shown = keywords.find(k => k.Keyword === (_nullishCoalesce(shownWord, () => ( _optionalChain([keywords, 'access', _4 => _4[0], 'optionalAccess', _5 => _5.Keyword])))))

  let preview
  let caption
  if (editing && draft) {
    // The keyword being written, with the welcome line saving it would give.
    const word = _keywords.normalizeKeyword.call(void 0, draft.keyword.Keyword)
    const draftLine = hasWelcomeLine
      ? _copy.welcomeLine.call(void 0, savedList({
        ...draft.keyword,
        Keyword: word || 'KEYWORD',
        Phrase: draft.keyword.Phrase.trim() || 'what it\'s for',
      }))
      : ''
    preview = (
      _react2.default.createElement(_Preview.Phone, { phone: phone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
        ,  stopLine && _react2.default.createElement(_Preview.FirstText, { line: draftLine, stopLine: stopLine, isLineFocused: draft.isPhraseFocused, __self: this, __source: {fileName: _jsxFileName, lineNumber: 190}} ) 
        , _react2.default.createElement(_Preview.Exchange, { keyword: word, reply: draft.keyword.Reply.trim(), __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}} )
      )
    )
    caption = `${draft.keyword.Reply.length} / ${_keywords.MAX_REPLY_LENGTH} characters`
  } else {
    preview = (
      _react2.default.createElement(_react2.default.Fragment, null
        ,  !!keywords.length && (
          _react2.default.createElement(_components.Segmented, {
            label: "Show",
            options: [
              { value: WELCOME, label: 'Welcome' },
              ...keywords.map(k => ({ value: k.Keyword, label: k.Keyword })),
            ],
            value: shown && shownWord !== WELCOME ? shown.Keyword : WELCOME,
            onChange: setShownWord, __self: this, __source: {fileName: _jsxFileName, lineNumber: 199}}
          )
        )
        , _react2.default.createElement(_Preview.Phone, { phone: phone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 209}}
          ,  hasWelcomeLine && _react2.default.createElement(_Preview.FirstText, { line: line, stopLine: stopLine, slot: "Your keywords go here"   , __self: this, __source: {fileName: _jsxFileName, lineNumber: 210}} ) 
          ,  shown && shownWord !== WELCOME && _react2.default.createElement(_Preview.Exchange, { keyword: shown.Keyword, reply: shown.Reply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 211}} ) 
        )
      )
    )
    caption = shown && shownWord !== WELCOME
      ? shown.Flags
        ? _react2.default.createElement(_react2.default.Fragment, null, "Flagged: the chat waits in Requests as "       , _react2.default.createElement('strong', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 217}}, "↰ " ,  shown.Keyword ), ".")
        : 'Reply only: the text reaches your inbox like any other.'
      : !settings.Welcome
          ? 'First texts don\'t mention keywords.'
          : !stopLine
              ? 'Your organization has turned off the STOP line on first texts, so no keyword line is added.'
              : `First text from ${teamName}.`
  }

  return (
    _react2.default.createElement(_components.TabFrame, { preview: _react2.default.createElement('div', { 'data-testid': "keyword-preview", __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}},  preview ), caption: caption, __self: this, __source: {fileName: _jsxFileName, lineNumber: 227}}
      , _react2.default.createElement('div', { className: "team-page--card team-page--keywords" , 'data-testid': "team-page--keywords", __self: this, __source: {fileName: _jsxFileName, lineNumber: 228}}
        , _react2.default.createElement('div', { className: "team-page--keywords--head", __self: this, __source: {fileName: _jsxFileName, lineNumber: 229}}
          , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 230}}
            , _react2.default.createElement('div', { className: "team-page--card--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}}, "Keywords")
            , _react2.default.createElement('div', { className: "team-page--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 232}}, "When a family texts "
                  ,  phone , ", or sends in a secure chat, just one of these words (in any case), they get its reply right away. Flagged chats show in Requests for everyone on this team."

            )
          )
          , _react2.default.createElement('div', { className: "team-page--keywords--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 237}}
            ,  !isEmpty && _react2.default.createElement(_CopyPrompts2.default, { keywords: keywords, phoneNumber: phone, __self: this, __source: {fileName: _jsxFileName, lineNumber: 238}} ) 
            ,  canEdit && (
              _react2.default.createElement(_Form.Button, {
                className: "team-page--keywords--add-btn",
                isDisabled: !!editing,
                onClick: () => startEditing({ kind: 'new' }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 240}}
, "+ Add keyword"

              )
            )
          )
        )

        ,  isEmpty ? (
          _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(Steps, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 253}} )
            ,  !canEdit && _react2.default.createElement('div', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 254}}, "Only org admins can add keywords."     ) 
          )
        ) : (
          _react2.default.createElement(_react2.default.Fragment, null
            ,  !canEdit && (
              _react2.default.createElement('div', { className: "team-page--keywords--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 259}}
                , _react2.default.createElement('img', { src: "/assets/icons/padlock.svg", alt: "", className: "team-page--keywords--icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 260}} ), "Only org admins can change keywords."

              )
            )
            , _react2.default.createElement('div', { className: "team-page--keywords--table", __self: this, __source: {fileName: _jsxFileName, lineNumber: 264}}
              , _react2.default.createElement('div', { className: "team-page--keywords--row team-page--keywords--row--header" , 'aria-hidden': true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 265}}
                , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 266}}, "Keyword")
                , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 267}}, "Reply")
                , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 268}}, "In the inbox"  )
                , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 269}} )
              )
              ,  _optionalChain([editing, 'optionalAccess', _6 => _6.kind]) === 'new' && form() 
              ,  keywords.map(k => _optionalChain([editing, 'optionalAccess', _7 => _7.kind]) === 'edit' && editing.keyword === k.Keyword
                ? _react2.default.createElement(_react2.default.Fragment, { key: k.Keyword, __self: this, __source: {fileName: _jsxFileName, lineNumber: 273}},  form(k) )
                : (
                  _react2.default.createElement('div', { key: k.Keyword, className: "team-page--keywords--row", 'data-testid': "keyword-row", __self: this, __source: {fileName: _jsxFileName, lineNumber: 275}}
                    , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}, _react2.default.createElement('span', { className: "team-page--keywords--chip", __self: this, __source: {fileName: _jsxFileName, lineNumber: 276}}, "↰ " ,  k.Keyword ))
                    , _react2.default.createElement('div', { className: "team-page--keywords--reply", title: k.Reply, __self: this, __source: {fileName: _jsxFileName, lineNumber: 277}},  k.Reply )
                    , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 278}}
                      ,  canEdit ? (
                        _react2.default.createElement('button', {
                          type: "button",
                          className: k.Flags ? 'team-page--keywords--flag-pill' : 'team-page--keywords--flag-pill team-page--keywords--flag-pill--off',
                          title: k.Flags ? 'Click to only reply' : 'Click to flag the chat',
                          onClick: () => onFlip(k, !k.Flags), __self: this, __source: {fileName: _jsxFileName, lineNumber: 280}}

                          ,  k.Flags ? 'Flags the chat' : 'Reply only' 
                          , _react2.default.createElement('span', { className: "team-page--sr-only", __self: this, __source: {fileName: _jsxFileName, lineNumber: 287}}, " for "  ,  k.Keyword )
                        )
                      ) : (
                        _react2.default.createElement('span', { className: k.Flags ? 'team-page--keywords--flags' : 'team-page--keywords--muted', __self: this, __source: {fileName: _jsxFileName, lineNumber: 290}}
                          ,  k.Flags ? 'Flags the chat' : 'Reply only' 
                        )
                      )
                    )
                    , _react2.default.createElement('div', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 295}}
                      ,  canEdit && (
                        _react2.default.createElement('button', {
                          type: "button",
                          className: "team-page--keywords--link-btn",
                          'aria-label': `Edit ${k.Keyword}`,
                          disabled: !!editing,
                          onClick: () => startEditing({ kind: 'edit', keyword: k.Keyword }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 297}}
, "Edit"

                        )
                      )
                    )
                  )
                  ))
            )
          )
        )
      )

      , _react2.default.createElement(WelcomeSection, {
        line: line,
        isOn: settings.Welcome,
        stopLine: stopLine,
        canEdit: canEdit,
        onToggle: onToggleWelcome,
        onShow: () => setShownWord(WELCOME), __self: this, __source: {fileName: _jsxFileName, lineNumber: 315}}
      )

      , _react2.default.createElement(BuiltIns, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 324}} )

      , _react2.default.createElement(_Modal2.default, { isOpen: !!deleting, onClose: () => setDeleting(''), title: `Delete ${deleting}?`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 326}}
        , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 327}}, "Patients who text "
             , deleting, " will get no reply, and the text will reach your inbox like any other."
        )
        , _react2.default.createElement(_Modal.ModalControls, {
          primaryBtnLabel: "Delete",
          primaryBtnTheme: "danger",
          onPrimaryBtnClick: onConfirmDelete,
          secondaryBtnLabel: "Cancel",
          onSecondaryBtnClick: () => setDeleting(''), __self: this, __source: {fileName: _jsxFileName, lineNumber: 330}}
        )
      )
    )
  )
}












const WelcomeSection = ({ line, isOn, stopLine, canEdit, onToggle, onShow }) => (
  _react2.default.createElement('div', { className: "team-page--card team-page--keywords--welcome" , 'data-testid': "keywords-welcome", __self: this, __source: {fileName: _jsxFileName, lineNumber: 354}}
    , _react2.default.createElement('div', { className: "team-page--keywords--welcome-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 355}}
      ,  canEdit ? (
        _react2.default.createElement(_Form.Toggle, {
          isChecked: isOn,
          onChange: onToggle,
          label: "Mention keywords in the welcome text"     ,
          className: "team-page--keywords--welcome-toggle", __self: this, __source: {fileName: _jsxFileName, lineNumber: 357}}
        )
      ) : (
        _react2.default.createElement('div', { className: "team-page--keywords--strong", __self: this, __source: {fileName: _jsxFileName, lineNumber: 364}}, "Mention keywords in the welcome text: "
                ,  isOn ? 'on' : 'off' 
        )
      )
      , _react2.default.createElement('div', { className: "team-page--keywords--muted", __self: this, __source: {fileName: _jsxFileName, lineNumber: 368}}
        ,  isOn && stopLine && line
          ? `Adds ${line.length + 1} characters to each patient's first text.`
          : 'Adds one line to each family\'s first text.' 
      )
      ,  isOn && !stopLine && (
        _react2.default.createElement('div', { className: "team-page--keywords--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 374}}, "Your organization has turned off the STOP line on first texts, so this line won’t be added."

        )
      )
    )
    , _react2.default.createElement('button', { type: "button", className: "team-page--keywords--link-btn", onClick: onShow, __self: this, __source: {fileName: _jsxFileName, lineNumber: 379}}, "Preview")
  )
)

exports. default = KeywordsTab
